import supabase from "./supabase";
import { FunctionsHttpError } from "@supabase/supabase-js";

export interface RawAdmin {
  id: string;
  fullname: string;
  email: string;
  district: string;
  districtName: string;
  created_at: string;
}

export interface GetAdminsParams {
  search?: string;
}

export async function getAdmins(params?: GetAdminsParams): Promise<{
  data: RawAdmin[] | null;
  error: string | null;
}> {
  const { error, data } = await supabase.functions.invoke("getAdmins", {
    body: params,
  });

  if (error) {
    if (error instanceof FunctionsHttpError) {
      const errorMessage = await error.context.json();
      return { error: errorMessage.error, data: null };
    } else {
      return { error: error?.message || null, data: null };
    }
  }

  return { data: data?.admins ?? null, error: null };
}
